import { useEffect, useRef, useState } from "react";

/** Animated count-up for numeric stats. Accepts string with optional + suffix. */
export const CountUp = ({ end, duration = 1500, prefix = "", suffix = "", className = "" }) => {
  const ref = useRef(null);
  const [val, setVal] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const target = parseFloat(end) || 0;
          const animate = (now) => {
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setVal(target * eased);
            if (progress < 1) requestAnimationFrame(animate);
            else setVal(target);
          };
          requestAnimationFrame(animate);
        }
      },
      { threshold: 0.4 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [end, duration]);

  const formatted = Number.isInteger(parseFloat(end))
    ? Math.round(val).toLocaleString("hu-HU")
    : val.toFixed(1);

  return (
    <span ref={ref} className={className}>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
};

export default CountUp;
